import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "dialog-footer" }

import { computed, ref, Ref, onMounted, reactive } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { getOperatorNotiConfig, upsertOperatorNotiConfig } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { NotiChannel, SMSProvider } from '@/types/types'
import InfoTooltip from '@/components/InfoTooltip.vue'
import useFormRules from '@/hooks/useFormRules'
import FormRulesFactory from '@/common/formRules'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OperatorNoti',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 2选1
  brandId: {
    type: String,
  },
  operatorId: {
    // 必须是brand 所属的运营商id
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const formRefs = reactive<Record<string, any>>({})
// 回调函数动态存储表单实例
const setFormRef = (channel: string | number, el: any) => {
  formRefs[channel] = el
}
const getFormRules = (channel: any) => {
  return channel === NotiChannel.NC_SMS && formData.value.config.sms
    ? notiSmsFormRule
    : notiEmailFormRule
}
const notiSmsFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['config.sms.secretId', 'config.sms.secretKey', 'config.sms.host'],
    'inputEmpty',
    'inputInvalid',
  ),
})

const notiEmailFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['config.mail.sendHost', 'config.mail.userName', 'config.mail.password'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['config.mail.sendPort'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
    min: 1,
    max: 65535,
  }),
  ...FormRulesFactory.generateCustomRules(
    ['config.mail.defSenderMail'],
    'inputEmpty',
    'inputInvalid',
    {
      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    },
  ),
})

const { t } = useI18n()
const { getNotiChannelDesc, SMSProviders } = useProtocolEnums()

const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const addNotiConfigDialog = ref(false)
const addNotiConfigChannel = ref(NotiChannel.NC_UNKNOWN)

// const formCom1 = ref()
// const formCom2 = ref()
const editableTabsValue = ref(NotiChannel.NC_UNKNOWN)
const notiDatas = ref<any[]>([])
const formData: Ref<Record<string, any>> = ref({
  config: {},
})
const configLoading = ref(false)



const handleTabClick = (name: any) => {
  const foundItem = notiDatas.value.find((item) => item.channel == name)
  if (foundItem) {
    formData.value.config = foundItem
  }
}

const handleAddTab = () => {
  addNotiConfigChannel.value = NotiChannel.NC_UNKNOWN
  addNotiConfigDialog.value = true
}
const checkExists = (nc: NotiChannel) => {
  return !!notiDatas.value.find((item) => item.channel === nc)
}

const handleAddNotiConfigChannel = () => {
  addNotiConfigDialog.value = false

  if (addNotiConfigChannel.value == NotiChannel.NC_UNKNOWN) {
    return
  }

  let config = {
    operatorId: props.operatorId,
    channel: addNotiConfigChannel.value,
    sms: {
      secretId: '',
      secretKey: '',
      host: '',
      provider: SMSProvider.SMSP_WX,
    },
    mail: {
      sendHost: '',
      sendPort: '',
      userName: '',
      password: '',
      defSenderMail: '',
    },
    feishu: {
      webHook: '',
    },
  }
  notiDatas.value.push(config)
  editableTabsValue.value = addNotiConfigChannel.value
  formData.value.config = config
}

const isSubmitting = ref(false)
const submit = async () => {
  try {
    await formRefs[formData.value.config.channel].validate()
    isSubmitting.value = true
    if (formData.value.config.channel == NotiChannel.NC_SMS) {
      delete formData.value.config['mail']
      delete formData.value.config['feishu']
    } else if (formData.value.config.channel == NotiChannel.NC_MAIL) {
      delete formData.value.config['sms']
      delete formData.value.config['feishu']
    } else if (formData.value.config.channel == NotiChannel.NC_FEI_SHU) {
      delete formData.value.config['mail']
      delete formData.value.config['sms']
    }
    formData.value.config.BrandTerminalId = props.brandId
    formData.value.config.operatorId = props.operatorId

    await upsertOperatorNotiConfig(formData.value)
    ElMessage.success(t(`Base.updateSuccess`))
  } catch (error) {
    console.log('--->submit error: ', error)
  } finally {
    isSubmitting.value = false
  }
}

const loadData = async () => {
  try {
    configLoading.value = true
    const data = await getOperatorNotiConfig({
      brandID: props.brandId,
      operatorID: props.operatorId,
    })
    if (Array.isArray(data.configs)) {
      notiDatas.value = data.configs // 确保返回的是数组
      if (notiDatas.value.length > 0) {
        // let desc = getNotiChannelDesc(notiDatas.value[0].channel);
        editableTabsValue.value = notiDatas.value[0].channel
        formData.value.config = notiDatas.value[0]
      }
    } else {
      editableTabsValue.value = NotiChannel.NC_UNKNOWN
      notiDatas.value = [] // 如果返回的不是数组，初始化为空数组
      console.error('Invalid data format, expected an array.')
    }
    // rawData = cloneDeep(configs.value)
    console.log('--->rawData: ', notiDatas.value)
  } catch (error) {
    console.log('--->load error: ', error)
  } finally {
    configLoading.value = false
  }
}
loadData()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "app-card allow-overflow custom-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: editableTabsValue.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editableTabsValue).value = $event)),
          type: "card",
          addable: "",
          class: "demo-tabs",
          onEdit: handleAddTab,
          onTabChange: handleTabClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notiDatas.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: item.channel,
                label: _unref(getNotiChannelDesc)(item.channel),
                name: item.channel
              }, {
                default: _withCtx(() => [
                  (item.channel)
                    ? (_openBlock(), _createBlock(_component_el_form, {
                        key: 0,
                        ref_for: true,
                        ref: (el) => setFormRef(item.channel, el),
                        rules: getFormRules(item.channel),
                        model: formData.value,
                        "label-position": "right",
                        size: "default",
                        "label-width": "300px",
                        style: {"max-width":"800px"}
                      }, {
                        default: _withCtx(() => [
                          (item.channel == _unref(NotiChannel).NC_SMS && formData.value.config.sms)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 0,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, { prop: "config.sms.provider" }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.smsProvider')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: formData.value.config.sms.provider,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.config.sms.provider) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SMSProviders), (inx) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  label: inx.label,
                                                  value: inx.value,
                                                  key: inx.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.sms.secretId",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.smsAccessKeyId')), 1),
                                          _createVNode(InfoTooltip, {
                                            content: _ctx.$t('Operation.smsAccessKeyDesc')
                                          }, null, 8, ["content"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.sms.secretId,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.config.sms.secretId) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.sms.secretKey",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.smsAccessKeySecret')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.sms.secretKey,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.config.sms.secretKey) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.sms.host",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.smsEndpointHost')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.sms.host,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.config.sms.host) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (formData.value.config.sms.provider == _unref(SMSProvider).SMSP_WX)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 0,
                                        span: 24
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            prop: "config.sms.appId",
                                            required: ""
                                          }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.appid')), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ElInput), {
                                                modelValue: formData.value.config.sms.appId,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.config.sms.appId) = $event))
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (formData.value.config.sms.provider == _unref(SMSProvider).SMSP_WX)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 1,
                                        span: 24
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            prop: "config.sms.signName",
                                            required: ""
                                          }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.signName')), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ElInput), {
                                                modelValue: formData.value.config.sms.signName,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.config.sms.signName) = $event))
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (formData.value.config.sms.provider == _unref(SMSProvider).SMSP_WX)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 2,
                                        span: 24
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            prop: "config.sms.tmplId",
                                            required: ""
                                          }, {
                                            label: _withCtx(() => [
                                              _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.commTmplId')), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ElInput), {
                                                modelValue: formData.value.config.sms.tmplId,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.config.sms.tmplId) = $event))
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (item.channel == _unref(NotiChannel).NC_MAIL && formData.value.config.mail)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 1,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.mail.sendHost",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.emailSendHost')), 1),
                                          _createVNode(InfoTooltip, {
                                            content: _ctx.$t('Operation.smtpDesc')
                                          }, null, 8, ["content"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.mail.sendHost,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.config.mail.sendHost) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.mail.sendPort",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.emailSendPort')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.mail.sendPort,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.config.mail.sendPort) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.mail.userName",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.emailUserName')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.mail.userName,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.config.mail.userName) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.mail.password",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.emailPassword')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.mail.password,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.config.mail.password) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.mail.defSenderMail",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.emailDefSenderMail')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.mail.defSenderMail,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.config.mail.defSenderMail) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (item.channel == _unref(NotiChannel).NC_FEI_SHU && formData.value.config.feishu)
                            ? (_openBlock(), _createBlock(_component_el_row, {
                                key: 2,
                                gutter: 20
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        prop: "config.feishu.webHook",
                                        required: ""
                                      }, {
                                        label: _withCtx(() => [
                                          _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.webHook')), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_unref(ElInput), {
                                            modelValue: formData.value.config.feishu.webHook,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.config.feishu.webHook) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_col, {
                            span: 24,
                            class: "btn-col"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: !_ctx.$hasPermission('post'),
                                loading: isSubmitting.value,
                                onClick: submit
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('Base.saveChanges')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["rules", "model"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_unref(ElDialog), {
      modelValue: addNotiConfigDialog.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((addNotiConfigDialog).value = $event)),
      title: _unref(t)('Operation.selectNoti'),
      width: "30%",
      top: "25vh",
      "destroy-on-close": "",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleAddNotiConfigChannel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio_group, {
            modelValue: addNotiConfigChannel.value,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addNotiConfigChannel).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                value: _unref(NotiChannel).NC_MAIL,
                label: _unref(NotiChannel).NC_MAIL,
                disabled: checkExists(_unref(NotiChannel).NC_MAIL)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.email')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(NotiChannel).NC_SMS,
                label: _unref(NotiChannel).NC_SMS,
                disabled: checkExists(_unref(NotiChannel).NC_SMS)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.sms')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"]),
              _createVNode(_component_el_radio, {
                value: _unref(NotiChannel).NC_FEI_SHU,
                label: _unref(NotiChannel).NC_FEI_SHU,
                disabled: checkExists(_unref(NotiChannel).NC_FEI_SHU)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Operation.feishu')), 1)
                ]),
                _: 1
              }, 8, ["value", "label", "disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})